import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function leadRecommendationsApi() {
    return ApiRequest.fetchAdmin({
      method: "get",
      url: `${API_END_POINTS.LEAD_RECOMMENDATIONS}`,
    }).then((response) => response.data);
  }